var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.415 15.57C7.25 16.485 6.5 17.905 6.5 19.5V21H3.5C2.67 21 2 20.33 2 19.5V18.5C2 16.565 3.565 15 5.5 15H6.5C7.21 15 7.865 15.21 8.415 15.57Z",
    fill: "#829ED1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15C19.2426 15 20.25 13.9926 20.25 12.75C20.25 11.5074 19.2426 10.5 18 10.5C16.7574 10.5 15.75 11.5074 15.75 12.75C15.75 13.9926 16.7574 15 18 15Z",
    fill: "#829ED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C7.24264 15 8.25 13.9926 8.25 12.75C8.25 11.5074 7.24264 10.5 6 10.5C4.75736 10.5 3.75 11.5074 3.75 12.75C3.75 13.9926 4.75736 15 6 15Z",
    fill: "#829ED1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.5V19.5C22 20.33 21.33 21 20.5 21H17.5V19.5C17.5 17.905 16.75 16.485 15.585 15.57C16.135 15.21 16.79 15 17.5 15H18.5C20.435 15 22 16.565 22 18.5Z",
    fill: "#829ED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.5188 15.5 14.75 14.2688 14.75 12.75C14.75 11.2312 13.5188 10 12 10C10.4812 10 9.25 11.2312 9.25 12.75C9.25 14.2688 10.4812 15.5 12 15.5Z",
    fill: "#829ED1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5H11.5C9.2945 15.5 7.5 17.2945 7.5 19.5V21C7.5 21.827 8.173 22.5 9 22.5H15C15.827 22.5 16.5 21.827 16.5 21V19.5C16.5 17.2945 14.7055 15.5 12.5 15.5Z",
    fill: "#829ED1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 8.34166L18.0436 8.77066C17.7011 8.89216 17.3436 8.63266 17.3536 8.26916L17.3886 6.98916L16.6076 5.97416C16.3861 5.68616 16.5226 5.26566 16.8711 5.16266L18.0996 4.80066L18.8236 3.74416C19.0291 3.44466 19.4711 3.44466 19.6766 3.74416L20.4006 4.80066L21.6291 5.16266C21.9776 5.26516 22.1141 5.68616 21.8926 5.97416L21.1116 6.98916L21.1466 8.26916C21.1566 8.63216 20.7986 8.89216 20.4566 8.77066L19.2501 8.34166Z",
    fill: "#829ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75008 8.34166L3.54358 8.77066C3.20108 8.89216 2.84358 8.63266 2.85358 8.26916L2.88858 6.98916L2.10758 5.97416C1.88608 5.68616 2.02258 5.26566 2.37108 5.16266L3.59958 4.80066L4.32358 3.74416C4.52908 3.44466 4.97108 3.44466 5.17658 3.74416L5.90058 4.80066L7.12908 5.16266C7.47758 5.26516 7.61408 5.68616 7.39258 5.97416L6.61158 6.98916L6.64658 8.26916C6.65658 8.63216 6.29858 8.89216 5.95658 8.77066L4.75008 8.34166Z",
    fill: "#829ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.21665L10.5697 7.72515C10.1637 7.86965 9.73968 7.56115 9.75168 7.13065L9.79318 5.61315L8.86718 4.40965C8.60468 4.06815 8.76668 3.56965 9.17968 3.44765L10.6362 3.01815L11.4947 1.76565C11.7382 1.41015 12.2627 1.41015 12.5062 1.76565L13.3647 3.01815L14.8212 3.44765C15.2342 3.56965 15.3962 4.06815 15.1337 4.40965L14.2077 5.61315L14.2492 7.13065C14.2612 7.56115 13.8367 7.86965 13.4312 7.72515L12.0002 7.21665Z",
    fill: "#829ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.752ae7e9b7ae7c2b9a020d2ccc810749.svg";
export { ForwardRef as ReactComponent };